module.exports = "<template> <sio-geometry config.bind=field value.bind=field.value></sio-geometry> </template> ";